import { render } from "./DesktopHeader.vue?vue&type=template&id=d39f855c&scoped=true"
import script from "./DesktopHeader.vue?vue&type=script&lang=js"
export * from "./DesktopHeader.vue?vue&type=script&lang=js"

import "./DesktopHeader.vue?vue&type=style&index=0&id=d39f855c&scoped=true&lang=scss"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39f855c"]])

export default __exports__